import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import QRCode from "qrcode";
import { useContext, useEffect, useState } from 'react';
import { FrameworkContext } from '../../../cnr/contexts/FrameworkContent';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../../cnr/contexts/UiItemContext';
import { _appSidebarContentTypes } from '../../../cnr/reducers/FrameworkReducer';
import { convertHelpers } from '../../../common/convert';
import { gEnums } from '../../../enums/globalEnums';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';

/**
 * 
 * @param {object} props (qrCodeType, itemData, viewItem)
 * @returns 
 */
const QrCode = (props) => {

  const { qrCodeType, itemData, itemType, scanData, appSidebarContentType } = props ?? {}
  const _name = itemData ? convertHelpers.getItemName(itemData) : null

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_handlers } = frameworkContext ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()
  const { displayName, appUserSessionKey } = appUserAccess ?? {}

  // papsContext 
  const { pathViews, sharePath } = paps_state ?? {}

  // pageContext   
  const { aps_appUserSettings, aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { eventOptions, clientOptions } = aps_global ?? {}
  const _appOptions = { ...clientOptions, ...eventOptions }
  const { shortenedLink } = _appOptions ?? {}
  const { appUserCollection } = aps_appUserSettings ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_handlers } = uiItemContext ?? {}

  const [qrData, setQrData] = useState({});
  const [qrUrl, setQrUrl] = useState("");
  const [qrWidth, setQrWidth] = useState(300);

  useEffect(() => {
    let _qrData;
    switch (qrCodeType) {
      case gEnums.qrCodeTypes.appLink:
      case gEnums.qrCodeTypes.appLinkSide:
      case gEnums.qrCodeTypes.tempAccess:
        _qrData = qrAppLink()
        break;
      case gEnums.qrCodeTypes.appUser:
        setQrWidth(200)
        _qrData = qrAppUserScan()
        break;
      case gEnums.qrCodeTypes.itemData:
        _qrData = sharePath
        break;
      case gEnums.qrCodeTypes.scanData:
        _qrData = qrScanData()
        break;
      case gEnums.qrCodeTypes.gamificationAppUser:
        _qrData = qrAppUserScan()
        break;
      case gEnums.qrCodeTypes.gamificationItem:
        _qrData = qrGamification()
        break;
      default:
        _qrData = itemData
      // nothing
    }

    setQrData(_qrData)
    const encoded = btoa(JSON.stringify(_qrData));
    QRCode.toDataURL(encoded, { width: 256 })
      .then(setQrUrl)
      .catch(console.error);
  }, []);

  let cn = 'qr-container'
  if (qrCodeType === gEnums.qrCodeTypes.itemData) { cn += ' solo' }

  const handleCancel = () => {
    if (props.handleCancel) {
      props.handleCancel()
    } else if (item_handlers && item_handlers.handleShow_itemSidebar) {
      item_handlers.handleShow_itemSidebar()
    } else if (appSidebarContentType) {
      framework_handlers.handleShow_appSidebarContent()
    }
  }

  const copyToClipboard = (text) => {
    // Create a temporary textarea element
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);

    // Select and copy the text
    textarea.select();
    document.execCommand('copy');

    // Remove the temporary textarea
    document.body.removeChild(textarea);
    alert("Copied!");
  };

  const qrAppLink = () => appSidebarContentType === _appSidebarContentTypes.qrCodeShort && shortenedLink ? shortenedLink : sharePath

  // const qrAppUser = () => {
  //   const qv = {
  //     clientKey: pathViews ? pathViews.clients : null,
  //     eventKey: pathViews ? pathViews.events : null,
  //     [appUserCollection]: appUserSessionKey,
  //     displayName,
  //   }
  //   return qv
  // }

  const qrScanData = () => JSON.stringify(scanData)

  const qrAppUserScan = () => {
    const gi = {
      _itemKey: appUserSessionKey,
      itemType: 'appUser',
      name: _name,
    }
    return gi
  }

  const qrGamification = () => {
    const { _itemKey } = itemData ?? {}
    const gi = {
      _itemKey,
      itemType,
      name: _name,
    }
    return gi
  }

  const qrContent = () => {
    return <div className={cn} >
      <div style={{ textAlign: 'center' }}>
        <img src={qrUrl} alt="QR Code" style={{ width: qrWidth }} />
        {/* <div style={{ padding: '1em' }}>
          <TreeViewer data={qrData} />
        </div> */}
      </div>
    </div>
  }

  const topper2 = () => {
    switch (qrCodeType) {
      case gEnums.qrCodeTypes.appLink:
      case gEnums.qrCodeTypes.appLinkSide:
        return appSidebarContentType === _appSidebarContentTypes.qrCodeShort && shortenedLink ? shortenedLink : sharePath
      case gEnums.qrCodeTypes.appUser:
        return displayName
      case gEnums.qrCodeTypes.itemData:
      case gEnums.qrCodeTypes.gamificationItem:
      case gEnums.qrCodeTypes.gamificationAppUser:
        return _name
      default:
      // nothing
    }
  }

  const footer = () => {
    switch (qrCodeType) {
      case gEnums.qrCodeTypes.gamificationAppUser:
      case gEnums.qrCodeTypes.gamificationItem:
        return;
      default:
        <div onClick={() => { copyToClipboard(sharePath) }}>
          <div>{sharePath}</div>
          <div>{shortenedLink}</div>
        </div>
    }
  }

  const wrapper = () => <Wrapper
    content={qrContent(164)}
    footer={footer()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'QR Code'}
    topperCaption2={topper2()}
  />

  switch (qrCodeType) {
    case gEnums.qrCodeTypes.appLink:
    case gEnums.qrCodeTypes.itemData:
    case gEnums.qrCodeTypes.gamificationAppUser:
    case gEnums.qrCodeTypes.gamificationItem:
      return fullPageWrapper()
    default:
      return qrContent()
  }
}

export default QrCode